import { useMap } from "react-leaflet";
import { useEffect, useState, useMemo } from "react";
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux';
import { Warning, Close, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    IconButton,
    Tooltip,
    Collapse
} from '@mui/material';
import { $host } from "../../http";
import { Fragment } from "react";
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { setModal } from "../../store/reducers/helpersReducer";
const statusColors = {
    'construction': '#ff2b2b',
    'reconstruction': '#2196F3',
    'replacement': '#18c218'
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgb(40, 40, 40)',
        color: 'white',
        padding: 0,
        lineHeight: 1.3,
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    [`&.${tableCellClasses.body}`]: {
        color: 'white',
        padding: '0 5px',
        lineHeight: 1.1,
        fontSize: 12,
    },
}));

const ExpandableRow = ({ error }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow
                onClick={() => setOpen(!open)}
                sx={{
                    bgcolor: error.status === 'Не устранено' ? '#2c1f1f' : '#1f2c1f',
                    '&:hover': {
                        bgcolor: error.status === 'Не устранено' ? '#3c2f2f' : '#2f3c2f',
                        cursor: 'pointer'
                    },
                    '& .MuiTableCell-root': { py: 0.5, lineHeight: 1.2 }
                }}
            >
                <StyledTableCell>
                    {error.pillars && error.pillars.length > 0 ? (
                        <IconButton
                            size="small"
                            sx={{ color: 'white', p: 0 }}
                        >
                            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                    ) : null}
                </StyledTableCell>
                <StyledTableCell>{error.id}</StyledTableCell>
                <StyledTableCell>{error.number_opor}</StyledTableCell>
                <StyledTableCell>{error.tp_name}</StyledTableCell>
                <StyledTableCell>{error.status}</StyledTableCell>
                <StyledTableCell>{error.errors}</StyledTableCell>
            </TableRow>
            {error.pillars && error.pillars.length > 0 && (
                <TableRow>
                    <TableCell style={{ padding: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 1, bgcolor: 'rgb(30, 30, 30)' }}>
                                <Typography variant="subtitle2" sx={{ p: 0.5, color: 'white' }}>
                                    Найденные опоры:
                                </Typography>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            {/* <StyledTableCell>FID</StyledTableCell> */}
                                            <StyledTableCell>Имя</StyledTableCell>
                                            <StyledTableCell>Этап</StyledTableCell>
                                            <StyledTableCell>ТП</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {error.pillars.map((pillar) => (
                                            <TableRow
                                                key={pillar.fid}
                                                sx={{
                                                    '&:hover': {
                                                        bgcolor: 'rgb(50, 50, 50)',
                                                    },
                                                    '& .MuiTableCell-root': { py: 0.5, lineHeight: 1.2 }
                                                }}
                                            >
                                                {/* <StyledTableCell>{pillar.fid}</StyledTableCell> */}
                                                <StyledTableCell align="center">{pillar.name}</StyledTableCell>
                                                <StyledTableCell align="center">{pillar.stage}</StyledTableCell>
                                                <StyledTableCell align="center">{pillar.tp_name}</StyledTableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

const ModalBindingErrors = (props) => {
    const dispatch = useDispatch()
    const accountingErrors = useSelector(state => state.state.bindingErrors)

    const { buttonPosition } = props || {};



    // Memoized styles with dynamic positioning
    const dialogBoxStyles = useMemo(() => {
        const button = document.getElementById('binding-errors-button')
        const buttonPosition = button ? button.getBoundingClientRect() : null
        console.log(button.getClientRects())
        console.log(buttonPosition)
        const baseStyles = {
            position: 'absolute',
            zIndex: 1202,
            backgroundColor: '#1a1a1a',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            border: '1px solid #333',
            overflow: 'hidden',
            transition: 'all 0.3s ease-in-out',
            color: '#ffffff',
            opacity: 0.95,
            p: 0,
            transformOrigin: 'left top',
            transform: window.innerWidth < 768 ? 'scale(0.8)' : 'scale(1)',
        };

        const responsiveStyles = {
            ...baseStyles,
            width: 'auto',
            minWidth: '280px',
            maxWidth: '400px',
            height: 'auto',
            maxHeight: '80vh',
            borderRadius: 2
        };

        // Вычисляем позицию на основе позиции кнопки
        if (buttonPosition) {
            console.log(buttonPosition);
            const modalWidth = 300;
            const modalHeight = 600;

            // Позиционируем справа от кнопки с отступом
            let left = buttonPosition.right + 8;
            let top = buttonPosition.top - 2;

            // Проверяем, не выходит ли модальное окно за правый край экрана
            // if (left + modalWidth > window.innerWidth) {
            //     // Позиционируем слева от кнопки
            //     left = buttonPosition.left - modalWidth - 10;
            // }

            // // Проверяем, не выходит ли за левый край
            // if (left < 10) {
            //     left = 10;
            // }

            // // Проверяем, не выходит ли за нижний край экрана
            // if (top + modalHeight > window.innerHeight) {
            //     top = window.innerHeight - modalHeight - 10;
            // }

            // // Проверяем, не выходит ли за верхний край
            // if (top < 10) {
            //     top = 10;
            // }

            return {
                ...responsiveStyles,
                left: `${left}px`,
                top: `${top}px`,
                margin: 0
            };
        }

        // Дефолтное позиционирование (если buttonPosition не передан)
        return {
            ...responsiveStyles,
            margin: '10px 10px 5px 5px'
        };
    }, []);
    return (
        createPortal(
            <Box sx={dialogBoxStyles}>
                <Paper
                    elevation={3}
                    sx={{
                        width: 400,
                        maxHeight: 400,
                        // m: '5px 10px',
                        bgcolor: 'rgb(40, 40, 40)',
                        color: 'white',
                        overflow: 'hidden',
                        opacity: 0.9,
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'rgb(100, 100, 100) rgb(40, 40, 40)',
                        '&::-webkit-scrollbar': {
                            width: '5px',
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: 'rgb(40, 40, 40)',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgb(100, 100, 100)',
                        },
                    }}
                >
                    {accountingErrors && accountingErrors.length > 0 ? (
                        <Fragment>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ ml: 1 }}>
                                    Предписания без опор - {accountingErrors.length}
                                </Typography>
                                <IconButton
                                    size="small"
                                    onClick={() => dispatch(setModal(null))}
                                    sx={{ color: 'white' }}
                                >
                                    <Close />
                                </IconButton>
                            </Box>
                            <TableContainer sx={{ maxHeight: 350 }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow sx={{ '& .MuiTableCell-root': { py: 0.5, lineHeight: 1.2 } }}>
                                            <StyledTableCell sx={{ bgcolor: '#2c2c2c', color: 'white' }}></StyledTableCell>
                                            <StyledTableCell sx={{ bgcolor: '#2c2c2c', color: 'white' }}>Id</StyledTableCell>
                                            <StyledTableCell sx={{ bgcolor: '#2c2c2c', color: 'white' }}>№ опоры</StyledTableCell>
                                            <StyledTableCell sx={{ bgcolor: '#2c2c2c', color: 'white' }}>ТП</StyledTableCell>
                                            <StyledTableCell sx={{ bgcolor: '#2c2c2c', color: 'white' }}>Статус</StyledTableCell>
                                            <StyledTableCell sx={{ bgcolor: '#2c2c2c', color: 'white' }}>Ошибка</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {accountingErrors.map((error) => (
                                            <ExpandableRow key={error.id} error={error} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Fragment>
                    ) : null}
                </Paper>

            </Box>,
            document.body
        )
    )
}

export default ModalBindingErrors;
